<ul class="action-menu">
    <li *ngIf="!newsfeed_muted"
        (click)="mute()">
        <a>{{ 'NEWSFEED_MUTE_PARTICIPANT' | trns }}</a>
    </li>
    <li *ngIf="newsfeed_muted"
        (click)="unmute()">
        <a *ngIf="newsfeed_muted"
           (click)="unmute()">{{ 'NEWSFEED_UNMUTE_PARTICIPANT' | trns }}</a>
    </li>
    <li (click)="report()">
        <a>{{ 'NEWSFEED_REPORT_POST' | trns }}</a>
    </li>
</ul>